export default __webpack_public_path__ + "static/media/video_polygon_before.0ebd9061.mp4";